/*
 * Copyright (C) Motorola Solutions, INC.
 * All Rights Reserved.
 */

import { AgentStatus } from 'CalltakingCoreApi';

export enum AcdReadyStatus {
    READY = 'READY',
    NOT_READY = 'NOT_READY'
}

export interface RequestedAgentStatus {
    status: AgentStatus,
    clusterName?: string;
    isAgentRequested?: boolean;
    statusReasonDisplayName?: string;
    statusReasonId?: string;
}
